/*
 * =====================================================================================
 * DISCLAIMER:
 * =====================================================================================
 * This localization file is a community contribution and is not officially maintained
 * by Clerk. It has been provided by the community and may not be fully aligned
 * with the current or future states of the main application. Clerk does not guarantee
 * the accuracy, completeness, or timeliness of the translations in this file.
 * Use of this file is at your own risk and discretion.
 * =====================================================================================
 */

export const deDE = {
  locale: "de-DE",
  __experimental_userVerification: {
    alternativeMethods: {
      actionLink: "Klicke hier, um eine alternative Methode zu verwenden",
      actionText: "Verwende eine alternative Verifizierungsmethode",
      blockButton__backupCode: "Mit Backup-Code verifizieren",
      blockButton__emailCode: "Mit E-Mail-Code verifizieren",
      blockButton__password: "Mit Passwort verifizieren",
      blockButton__phoneCode: "Mit SMS-Code verifizieren",
      blockButton__totp: "Mit TOTP verifizieren",
      getHelp: {
        blockButton__emailSupport: "E-Mail-Support kontaktieren",
        content:
          "Wenn du Hilfe benötigst, wende dich bitte an unseren Support.",
        title: "Hilfe erhalten",
      },
      subtitle: "Wähle eine Methode, um dich zu verifizieren",
      title: "Verifizierung erforderlich",
    },
    backupCodeMfa: {
      subtitle:
        "Verwende den Backup-Code, der dir bei der Registrierung zur Verfügung gestellt wurde.",
      title: "Backup-Code Verifizierung",
    },
    emailCode: {
      formTitle:
        "Gib den Code ein, den wir an deine E-Mail-Adresse gesendet haben.",
      resendButton: "Code erneut senden",
      subtitle: "Überprüfe deine E-Mail auf den Verifizierungscode.",
      title: "E-Mail-Code Verifizierung",
    },
    noAvailableMethods: {
      message: "Es sind keine Verifizierungsmethoden mehr verfügbar.",
      subtitle: "Bitte kontaktiere den Support, um Hilfe zu erhalten.",
      title: "Keine verfügbaren Methoden",
    },
    password: {
      actionLink: "Passwort zurücksetzen",
      subtitle: "Gib dein Passwort ein, um fortzufahren.",
      title: "Passwort-Verifizierung",
    },
    phoneCode: {
      formTitle:
        "Gib den Code ein, den wir an deine Telefonnummer gesendet haben.",
      resendButton: "Code erneut senden",
      subtitle: "Überprüfe deine SMS-Nachricht auf den Verifizierungscode.",
      title: "SMS-Code Verifizierung",
    },
    phoneCodeMfa: {
      formTitle: "Gib den Code ein, den wir dir per SMS gesendet haben.",
      resendButton: "Code erneut senden",
      subtitle: "Überprüfe deine SMS auf den Verifizierungscode.",
      title: "SMS-Code (MFA) Verifizierung",
    },
    totpMfa: {
      formTitle: "Gib den Code aus deiner Authentifikator-App ein.",
      subtitle: "Verwende die Authentifikator-App, die du eingerichtet hast.",
      title: "TOTP-Verifizierung (MFA)",
    },
  },
  backButton: "Zurück",
  badge__activePlan: "Aktiv",
  badge__canceledEndsAt: "Storniert • Endet am {{ date | shortDate('de-DE') }}",
  badge__currentPlan: "Aktueller Plan",
  badge__default: "Standard",
  badge__endsAt: "Endet am {{ date | shortDate('de-DE') }}",
  badge__expired: "Abgelaufen",
  badge__otherImpersonatorDevice: "Anderes Imitationsgerät",
  badge__primary: "Primär",
  badge__renewsAt: "Verlängert sich am {{ date | shortDate('de-DE') }}",
  badge__requiresAction: "Erfordert Handeln",
  badge__startsAt: "Startet am {{ date | shortDate('de-DE') }}",
  badge__thisDevice: "Dieses Gerät",
  badge__unverified: "Unbestätigt",
  badge__upcomingPlan: "Bevorstehend",
  badge__userDevice: "Benutzergerät",
  badge__you: "Du",
  commerce: {
    addPaymentMethod: "Zahlungsmethode hinzufügen",
    alwaysFree: "Immer kostenlos",
    annually: "Jährlich",
    availableFeatures: "Verfügbare Funktionen",
    billedAnnually: "Jährlich abgerechnet",
    billedMonthlyOnly: "Nur monatlich abgerechnet",
    cancelSubscription: "Abonnement kündigen",
    cancelSubscriptionAccessUntil:
      "Du hast Zugriff auf '{{plan}}' Funktionen bis zum {{ date | longDate('de-DE') }}. Danach hast du keinen Zugriff mehr.",
    cancelSubscriptionNoCharge: "Für dieses Abonnement fallen keine Kosten an.",
    cancelSubscriptionTitle: "{{plan}} Abonnement kündigen?",
    cannotSubscribeMonthly:
      "Du kannst diesen Plan nicht monatlich abonnieren, da nur eine jährliche Abrechnung verfügbar ist.",
    checkout: {
      description__paymentSuccessful: "Deine Bezahlung war erfolgreich.",
      description__subscriptionSuccessful:
        "Dein Abonnement wurde erfolgreich aktiviert.",
      downgradeNotice:
        "Du behältst dein aktuelles Abonnement bis zum Ende des Abrechnungszeitraums. So lange kannst du weiterhin alle Funktionen nutzen, danach wirst du auf dieses Abonnement umgestellt.",
      emailForm: {
        subtitle:
          "Gib eine E-Mail-Adresse an, um Abrechnungsbelege zu erhalten.",
        title: "E-Mail-Adresse hinzufügen",
      },
      lineItems: {
        title__paymentMethod: "Bezahlmethode",
        title__statementId: "Statement-ID",
        title__subscriptionBegins: "Abonnement beginnt",
        title__totalPaid: "Insgesamt bezahlt",
      },
      perMonth: "pro Monat",
      title: "Bezahlung",
      title__paymentSuccessful: "Zahlung erfolgreich!",
      title__subscriptionSuccessful: "Geschafft!",
    },
    creditRemainder:
      "Verbleibendes Guthaben für den restlichen Abrechnungszeitraum.",
    defaultFreePlanActive: "Du nutzt aktuell den kostenlosen Plan.",
    free: "Kostenlos",
    getStarted: "Jetzt starten",
    keepSubscription: "Abonnement behalten",
    manage: "Verwalten",
    manageSubscription: "Mitgliedschaft verwalten",
    month: "Monat",
    monthly: "Monatlich",
    pastDue: undefined,
    pay: "{{amount}} bezahlen",
    paymentMethods: "Zahlungsmethoden",
    paymentSource: {
      applePayDescription: {
        annual: "Jährlich abgerechnet",
        monthly: "Monatlich abgerechnet",
      },
      dev: {
        anyNumbers: "Alle Zahlen",
        cardNumber: "Kartennummer",
        cvcZip: "CVC, PLZ",
        developmentMode: "Entwicklermodus",
        expirationDate: "Ablaufdatum",
        testCardInfo: "Test-Kreditkarteninformationen",
      },
    },
    popular: "Beliebt",
    pricingTable: {
      billingCycle: "Abrechnungszyklus",
      included: "Enthalten",
    },
    reSubscribe: "Erneut abonnieren",
    seeAllFeatures: "Alle Funktionen anzeigen",
    subscribe: "Abonnieren",
    subtotal: "Zwischensumme",
    switchPlan: "Zu diesem Plan wechseln",
    switchToAnnual: "Wechsel zu jährlich",
    switchToMonthly: "Wechsel zu monatlich",
    totalDueToday: "Heute fällig",
    viewFeatures: "Funktionen anzeigen",
    year: "Jahr",
  },
  createOrganization: {
    formButtonSubmit: "Organisation erstellen",
    invitePage: {
      formButtonReset: "Überspringen",
    },
    title: "Organisation erstellen",
  },
  dates: {
    lastDay: "Gestern um {{ date | timeString('de-DE') }}",
    next6Days:
      "{{ date | weekday('de-DE','long') }} bei {{ date | timeString('de-DE') }}",
    nextDay: "Morgen um {{ date | timeString('de-DE') }}",
    numeric: "{{ date | numeric('de-DE') }}",
    previous6Days:
      "Letzte {{ date | weekday('de-DE','long') }} um {{ date | timeString('de-DE') }}",
    sameDay: "Heute um {{ date | timeString('de-DE') }}",
  },
  dividerText: "oder",
  footerActionLink__alternativePhoneCodeProvider: undefined,
  footerActionLink__useAnotherMethod: "Verwende eine andere Methode",
  footerPageLink__help: "Hilfe",
  footerPageLink__privacy: "Privatsphäre",
  footerPageLink__terms: "Bedingungen",
  formButtonPrimary: "Fortsetzen",
  formButtonPrimary__verify: "Verifizieren",
  formFieldAction__forgotPassword: "Passwort vergessen?",
  formFieldError__matchingPasswords: "Passwörter stimmen überein.",
  formFieldError__notMatchingPasswords: "Passwörter stimmen nicht überein.",
  formFieldError__verificationLinkExpired:
    "Der Bestätigungslink ist abgelaufen. Bitte fordere einen neuen Link an.",
  formFieldHintText__optional: "Optional",
  formFieldHintText__slug:
    "Der Slug ist eine für Menschen lesbare ID. Sie muss einzigartig sein und wird oft in URLs verwendet.",
  formFieldInputPlaceholder__backupCode: "Sicherheitscode eingeben",
  formFieldInputPlaceholder__confirmDeletionUserAccount: "Konto löschen",
  formFieldInputPlaceholder__emailAddress: "info@mein-unternehmen.com",
  formFieldInputPlaceholder__emailAddress_username: "info@mein-unternehmen.com",
  formFieldInputPlaceholder__emailAddresses:
    "Gib eine oder mehrere E-Mail-Adressen ein, getrennt durch Leerzeichen oder Kommas",
  formFieldInputPlaceholder__firstName: "Vorname",
  formFieldInputPlaceholder__lastName: "Nachname",
  formFieldInputPlaceholder__organizationDomain: "mein-unternehmen.com",
  formFieldInputPlaceholder__organizationDomainEmailAddress:
    "info@mein-unternehmen.com",
  formFieldInputPlaceholder__organizationName: "Mein Unternehmen",
  formFieldInputPlaceholder__organizationSlug: "mein-unternehmen",
  formFieldInputPlaceholder__password: "Passwort",
  formFieldInputPlaceholder__phoneNumber: "Telefonnummer",
  formFieldInputPlaceholder__username: "Benutzername",
  formFieldLabel__automaticInvitations:
    "Aktiviere automatische Einladungen für diese Domain",
  formFieldLabel__backupCode: "Sicherungscode",
  formFieldLabel__confirmDeletion: "Bestätigung",
  formFieldLabel__confirmPassword: "Passwort bestätigen",
  formFieldLabel__currentPassword: "Aktuelles Passwort",
  formFieldLabel__emailAddress: "E-Mail-Adresse",
  formFieldLabel__emailAddress_username: "E-Mail-Adresse oder Benutzername",
  formFieldLabel__emailAddresses: "E-Mail-Adressen",
  formFieldLabel__firstName: "Vorname",
  formFieldLabel__lastName: "Nachname",
  formFieldLabel__newPassword: "Neues Passwort",
  formFieldLabel__organizationDomain: "Domain",
  formFieldLabel__organizationDomainDeletePending:
    "Ausstehende Einladungen und Vorschläge löschen",
  formFieldLabel__organizationDomainEmailAddress:
    "E-Mail-Adresse für die Verifizierung",
  formFieldLabel__organizationDomainEmailAddressDescription:
    "Gib eine E-Mail-Adresse dieser Domain ein, um einen Code zu erhalten und diese Domain zu verifizieren.",
  formFieldLabel__organizationName: "Organisationsname",
  formFieldLabel__organizationSlug: "Slug",
  formFieldLabel__passkeyName: "Name des Passkeys",
  formFieldLabel__password: "Passwort",
  formFieldLabel__phoneNumber: "Telefonnummer",
  formFieldLabel__role: "Rolle",
  formFieldLabel__signOutOfOtherSessions: "Alle anderen Geräte abmelden",
  formFieldLabel__username: "Nutzername",
  impersonationFab: {
    action__signOut: "Ausloggen",
    title: "Angemeldet als {{identifier}}",
  },
  maintenanceMode:
    "Wir führen derzeit Wartungsarbeiten durch, aber keine Sorge, es sollte nicht länger als ein paar Minuten dauern.",
  membershipRole__admin: "Administrator",
  membershipRole__basicMember: "Mitglied",
  membershipRole__guestMember: "Gast",
  organizationList: {
    action__createOrganization: "Organisation erstellen",
    action__invitationAccept: "Beitreten",
    action__suggestionsAccept: "Beitritt anfragen",
    createOrganization: "Organisation erstellen",
    invitationAcceptedLabel: "Beitreten",
    subtitle: "um fortzufahren zu {{applicationName}}",
    suggestionsAcceptedLabel: "Genehmigung ausstehend",
    title: "Konto auswählen",
    titleWithoutPersonal: "Organisation auswählen",
  },
  organizationProfile: {
    badge__automaticInvitation: "Automatische Einladungen",
    badge__automaticSuggestion: "Automatische Vorschläge",
    badge__manualInvitation: "Keine automatische Aufnahme",
    badge__unverified: "Nicht verifiziert",
    billingPage: {
      paymentSourcesSection: {
        actionLabel__default: "Als Standard festlegen",
        actionLabel__remove: "Entfernen",
        add: "Neue Zahlungsmethode hinzufügen",
        addSubtitle: "Füge eine neue Zahlungsmethode hinzu.",
        cancelButton: "Abbrechen",
        formButtonPrimary__add: "Zahlungsmethode hinzufügen",
        formButtonPrimary__pay: "{{amount}} bezahlen",
        payWithTestCardButton: "Mit Test-Kreditkarte bezahlen",
        removeResource: {
          messageLine1: "{{identifier}} wird von diesem Konto entfernt.",
          messageLine2:
            "In Zukunft kannst du diese Zahlungsmethode nicht mehr verwenden. Alle laufenden Abonnements, die diese Zahlungsmethode verwenden, werden aufhören zu funktionieren.",
          successMessage: "{{paymentSource}} wurde von diesem Konto entfernt.",
          title: "Zahlungsmethode entfernen",
        },
        title: "Zahlungsmethoden",
      },
      start: {
        headerTitle__plans: "Pläne",
        headerTitle__statements: "Abrechnungen",
        headerTitle__subscriptions: "Abonnements",
      },
      subscriptionsListSection: {
        actionLabel__newSubscription: "Plan abonnieren",
        actionLabel__switchPlan: "Plan wechseln",
        title: "Abonnement",
      },
      subscriptionsSection: {
        actionLabel__default: "Verwalten",
      },
      switchPlansSection: {
        title: "Plan wechseln",
      },
      title: "Abrechnung",
    },
    createDomainPage: {
      subtitle:
        "Füge die zu überprüfende Domain hinzu. Benutzer mit E-Mail-Adressen von dieser Domain können der Organisation automatisch beitreten oder einen Antrag auf Beitritt stellen.",
      title: "Domain hinzufügen",
    },
    invitePage: {
      detailsTitle__inviteFailed:
        "Die Einladungen konnten nicht versendet werden. Behebe Folgendes und versuche es erneut:",
      formButtonPrimary__continue: "Einladungen verschicken",
      selectDropdown__role: "Rolle wählen",
      subtitle: "Lade neue Mitglieder zu dieser Organisation ein",
      successMessage: "Einladungen erfolgreich versendet",
      title: "Mitglieder einladen",
    },
    membersPage: {
      action__invite: "Einladen",
      action__search: "Suchen",
      activeMembersTab: {
        menuAction__remove: "Mitglied entfernen",
        tableHeader__actions: "Aktionen",
        tableHeader__joined: "Trat bei",
        tableHeader__role: "Rolle",
        tableHeader__user: "Benutzer",
      },
      detailsTitle__emptyRow: "Keine Mitglieder zum Anzeigen",
      invitationsTab: {
        autoInvitations: {
          headerSubtitle:
            "Lade Benutzer ein, indem du eine E-Mail-Domain mit deiner Organisation verbindest. Jeder, der sich mit dieser passenden E-Mail-Domain anmeldet, kann der Organisation jederzeit beitreten.",
          headerTitle: "Automatische Einladungen",
          primaryButton: "Verwalte verifizierte Domains",
        },
        table__emptyRow: "Keine Einladungen verfügbar",
      },
      invitedMembersTab: {
        menuAction__revoke: "Einladung widerrufen",
        tableHeader__invited: "Eingeladen",
      },
      requestsTab: {
        autoSuggestions: {
          headerSubtitle:
            "Benutzer, die sich mit einer passenden E-Mail-Domain anmelden, können einen Vorschlag für eine Beitrittsanfrage zu deiner Organisation sehen.",
          headerTitle: "Automatische Vorschläge",
          primaryButton: "Verifizierte Domains verwalten",
        },
        menuAction__approve: "Bestätigen",
        menuAction__reject: "Ablehnen",
        tableHeader__requested: "Angefragte Zugänge",
        table__emptyRow: "Keine Anfragen verfügbar",
      },
      start: {
        headerTitle__invitations: "Einladungen",
        headerTitle__members: "Mitglieder",
        headerTitle__requests: "Anfragen",
      },
    },
    navbar: {
      billing: "Abrechnung",
      description: "Verwalte deine Organisation.",
      general: "Allgemein",
      members: "Mitglieder",
      title: "Organisation",
    },
    plansPage: {
      alerts: {
        noPermissionsToManageBilling:
          "Du hast keine Berechtigung, die Abrechnungen für diese Organisation zu verwalten.",
      },
      title: "Pläne",
    },
    profilePage: {
      dangerSection: {
        deleteOrganization: {
          actionDescription:
            'Gib "{{organizationName}}" unten ein, um fortzufahren.',
          messageLine1:
            "Bist du sicher, dass du diese Organisation löschen willst?",
          messageLine2: "Diese Aktion ist dauerhaft und irreversibel.",
          successMessage: "Du hast die Organisation gelöscht.",
          title: "Organisation löschen",
        },
        leaveOrganization: {
          actionDescription:
            'Gib "{{organizationName}}" unten ein, um fortzufahren.',
          messageLine1:
            "Möchtest du diese Organisation wirklich verlassen? Du verlierst den Zugriff auf diese Organisation und deine Anwendungen.",
          messageLine2: "Diese Aktion ist dauerhaft und irreversibel.",
          successMessage: "Du hast die Organisation verlassen.",
          title: "Organisation verlassen",
        },
        title: "Achtung",
      },
      domainSection: {
        menuAction__manage: "Verwalten",
        menuAction__remove: "Löschen",
        menuAction__verify: "Verifizieren",
        primaryButton: "Domain hinzufügen",
        subtitle:
          "Erlaube Benutzern, der Organisation automatisch beizutreten oder den Beitritt auf der Grundlage einer verifizierten E-Mail-Domain anzufragen.",
        title: "Verifizierte Domains",
      },
      successMessage: "Die Organisation wurde aktualisiert.",
      title: "Organisationsprofil",
    },
    removeDomainPage: {
      messageLine1: "Die E-Mail-Domain {{domain}} wird entfernt.",
      messageLine2:
        "Benutzer können der Organisation danach nicht mehr automatisch beitreten.",
      successMessage: "{{domain}} wurde entfernt.",
      title: "Domain entfernen",
    },
    start: {
      headerTitle__general: "Allgemein",
      headerTitle__members: "Mitglieder",
      profileSection: {
        primaryButton: "Profil bearbeiten",
        title: "Organisationsprofil",
        uploadAction__title: "Logo",
      },
    },
    verifiedDomainPage: {
      dangerTab: {
        calloutInfoLabel:
          "Das Entfernen dieser Domain betrifft die eingeladenen Benutzer.",
        removeDomainActionLabel__remove: "Domain entfernen",
        removeDomainSubtitle:
          "Du kannst diese Domain von den verifizierten Domains entfernen",
        removeDomainTitle: "Domain entfernen",
      },
      enrollmentTab: {
        automaticInvitationOption__description:
          "Benutzer werden bei der Anmeldung automatisch eingeladen, der Organisation beizutreten, und können jederzeit beitreten.",
        automaticInvitationOption__label: "Automatische Einladungen",
        automaticSuggestionOption__description:
          "Benutzer erhalten einen Vorschlag für eine Beitrittsanfrage, müssen aber von einem Administrator genehmigt werden, bevor sie der Organisation beitreten können.",
        automaticSuggestionOption__label: "Automatische Vorschläge",
        calloutInfoLabel:
          "Änderungen des Anmeldemodus wirken sich nur auf neue Benutzer aus.",
        calloutInvitationCountLabel:
          "Ausstehende Einladungen gesendet an Benutzer: {{count}}",
        calloutSuggestionCountLabel:
          "Ausstehende Vorschläge gesendet an Benutzer: {{count}}",
        manualInvitationOption__description:
          "Benutzer können nur manuell in die Organisation eingeladen werden.",
        manualInvitationOption__label: "Keine automatische Aufnahme",
        subtitle:
          "Wähle, wie Benutzer mit dieser Domain der Organisation beitreten können.",
      },
      start: {
        headerTitle__danger: "Gefahr",
        headerTitle__enrollment: "Optionen für die Aufnahme",
      },
      subtitle:
        "Die Domain {{domain}} ist nun verifiziert. Bitte wähle einen Aufnahmemodus aus.",
      title: "{{domain}} aktualisieren",
    },
    verifyDomainPage: {
      formSubtitle:
        "Gib den an deine E-Mail-Adresse gesendeten Verifizierungscode ein",
      formTitle: "Verifizierungscode",
      resendButton: "Hast du keinen Code erhalten? Erneut senden",
      subtitle: "Die Domain {{domainName}} muss per E-Mail verifiziert werden.",
      subtitleVerificationCodeScreen:
        "Ein Verifizierungscode wurde an {{emailAddress}} gesendet. Gib den Code ein, um fortzufahren.",
      title: "Domain verifizieren",
    },
  },
  organizationSwitcher: {
    action__createOrganization: "Organisation erstellen",
    action__invitationAccept: "Beitreten",
    action__manageOrganization: "Organisation verwalten",
    action__suggestionsAccept: "Beitritt anfragen",
    notSelected: "Keine Organisation ausgewählt",
    personalWorkspace: "Persönlicher Arbeitsbereich",
    suggestionsAcceptedLabel: "Annahme ausstehend",
  },
  paginationButton__next: "Nächste",
  paginationButton__previous: "Vorherige",
  paginationRowText__displaying: "Anzeigen",
  paginationRowText__of: "von",
  signIn: {
    accountSwitcher: {
      action__addAccount: "Konto hinzufügen",
      action__signOutAll: "Von allen Konten abmelden",
      subtitle: "Wähle das Konto, mit dem du fortfahren möchtest.",
      title: "Wähle ein Konto",
    },
    alternativeMethods: {
      actionLink: "Hilfe",
      actionText: "Hast du keine davon?",
      blockButton__backupCode: "Verwende einen Backup-Code",
      blockButton__emailCode: "Code an {{identifier}} senden",
      blockButton__emailLink: "Link senden an {{identifier}}",
      blockButton__passkey: "Melde dich mit deinem Passkey an",
      blockButton__password: "Melde dich mit deinem Passwort an",
      blockButton__phoneCode: "Code an {{identifier}} senden",
      blockButton__totp: "Verwende deine Authentifizierungs-App",
      getHelp: {
        blockButton__emailSupport: "Unterstützung per E-Mail",
        content:
          "Wenn du Schwierigkeiten hast, dich mit deinem Konto anzumelden, sende uns eine E-Mail und wir werden mit dir zusammenarbeiten, um den Zugriff so schnell wie möglich wiederherzustellen.",
        title: "Hilfe",
      },
      subtitle:
        "Hast du Probleme? Du kannst eine der folgenden Methoden zur Anmeldung verwenden.",
      title: "Verwende eine andere Methode",
    },
    backupCodeMfa: {
      subtitle: "weiter zu {{applicationName}}",
      title: "Gib einen Backup-Code ein",
    },
    emailCode: {
      formTitle: "Bestätigungscode",
      resendButton: "Code erneut senden",
      subtitle: "weiter zu {{applicationName}}",
      title: "Überprüfe deinen Posteingang",
    },
    emailLink: {
      clientMismatch: {
        subtitle: "Die Anfrage stammt von einem nicht kompatiblen Client.",
        title: "Client-Kompatibilitätsfehler",
      },
      expired: {
        subtitle: "Kehre zum ursprünglichen Tab zurück, um fortzufahren.",
        title: "Dieser Bestätigungslink ist abgelaufen",
      },
      failed: {
        subtitle: "Kehre zum ursprünglichen Tab zurück, um fortzufahren.",
        title: "Dieser Bestätigungslink ist ungültig",
      },
      formSubtitle: "Verwende den an deine E-Mail gesendeten Bestätigungslink",
      formTitle: "Bestätigungslink",
      loading: {
        subtitle: "Du wirst in Kürze weitergeleitet",
        title: "Einloggen...",
      },
      resendButton: "Link erneut senden",
      subtitle: "weiter zu {{applicationName}}",
      title: "Überprüfe deinen Posteingang",
      unusedTab: {
        title: "Du kannst diesen Tab schließen",
      },
      verified: {
        subtitle: "Du wirst in Kürze weitergeleitet",
        title: "Erfolgreich angemeldet",
      },
      verifiedSwitchTab: {
        subtitle: "Kehre zum ursprünglichen Tab zurück, um fortzufahren",
        subtitleNewTab: "Kehre zum neu geöffneten Tab zurück, um fortzufahren",
        titleNewTab: "In einem anderen Tab angemeldet",
      },
    },
    forgotPassword: {
      formTitle: "Passwort-Code zurücksetzen",
      resendButton: "Du hast keinen Code erhalten? Erneut senden",
      subtitle: "um Passwort zurückzusetzen",
      subtitle_email: "Gib zunächst den an deine E-Mail gesendeten Code ein",
      subtitle_phone:
        "Gib zunächst den auf dein Mobiltelefon geschickten Code ein",
      title: "Passwort zurücksetzen",
    },
    forgotPasswordAlternativeMethods: {
      blockButton__resetPassword: "Passwort zurücksetzen",
      label__alternativeMethods: "Oder melde dich mit einer anderen Methode an",
      title: "Passwort vergessen?",
    },
    noAvailableMethods: {
      message:
        "Die Anmeldung kann nicht fortgesetzt werden. Es ist kein Authentifizierungsfaktor verfügbar.",
      subtitle: "Ein Fehler ist aufgetreten",
      title: "Anmeldung nicht möglich",
    },
    passkey: {
      subtitle:
        "Die Verwendung deines Passkeys bestätigt, dass du es bist. Dein Gerät kann nach deinem Fingerabdruck, deinem Gesicht oder der Bildschirmsperre fragen.",
      title: "Verwende deinen Passkey",
    },
    password: {
      actionLink: "Verwende eine andere Methode",
      subtitle: "weiter zu {{applicationName}}",
      title: "Gib dein Passwort ein",
    },
    passwordPwned: {
      title: "Passwort kompromittiert",
    },
    phoneCode: {
      formTitle: "Bestätigungscode",
      resendButton: "Code erneut senden",
      subtitle: "weiter zu {{applicationName}}",
      title: "Schau auf dein Telefon",
    },
    phoneCodeMfa: {
      formTitle: "Bestätigungscode",
      resendButton: "Code erneut senden",
      subtitle:
        "Um fortzufahren, gib bitte den Bestätigungscode ein, der an deine Telefonnummer gesendet wurde",
      title: "Schau auf dein Telefon",
    },
    resetPassword: {
      formButtonPrimary: "Passwort zurücksetzen",
      requiredMessage:
        "Es existiert bereits ein Konto mit einer nicht verifizierten E-Mail-Adresse. Bitte setze dein Passwort zur Sicherheit zurück.",
      successMessage:
        "Dein Passwort wurde erfolgreich geändert. Bitte warte einen Moment, um dich anzumelden.",
      title: "Neues Passwort setzen",
    },
    resetPasswordMfa: {
      detailsLabel:
        "Bevor wir dein Passwort zurücksetzen können, müssen wir deine Identität überprüfen.",
    },
    start: {
      actionLink: "Anmelden",
      actionLink__use_email: "E-mail nutzen",
      actionLink__use_email_username: "E-mail oder Benutzernamen nutzen",
      actionLink__use_passkey: "Passkey nutzen",
      actionLink__use_phone: "Mobiltelefon nutzen",
      actionLink__use_username: "Benutzername nutzen",
      actionText: "Kein Account?",
      subtitle: "weiter zu {{applicationName}}",
      title: "Einloggen",
    },
    totpMfa: {
      formTitle: "Bestätigungscode",
      subtitle:
        "Um fortzufahren, gib bitte den Verifizierungscode ein, der von deiner Authenticator-App generiert wurde.",
      title: "Bestätigung in zwei Schritten",
    },
  },
  signInEnterPasswordTitle: "Gib dein Passwort ein",
  signUp: {
    continue: {
      actionLink: "Einloggen",
      actionText: "Hast du ein Konto?",
      subtitle: "weiter zu {{applicationName}}",
      title: "Fülle fehlende Felder aus",
    },
    emailCode: {
      formSubtitle:
        "Gib den Bestätigungscode ein, der an deine E-Mail-Adresse gesendet wurde",
      formTitle: "Bestätigungscode",
      resendButton: "Code erneut senden",
      subtitle: "weiter zu {{applicationName}}",
      title: "Bestätige deine E-Mail",
    },
    emailLink: {
      clientMismatch: {
        subtitle:
          "Die Anfrage konnte nicht verarbeitet werden, da der Client nicht kompatibel ist.",
        title: "Fehler: Inkompatibler Client",
      },
      formSubtitle:
        "Verwende den an deine E-Mail-Adresse gesendeten Bestätigungslink",
      formTitle: "Bestätigungslink",
      loading: {
        title: "Anmeldung...",
      },
      resendButton: "Link erneut senden",
      subtitle: "weiter zu {{applicationName}}",
      title: "Bestätige deine E-Mail",
      verified: {
        title: "Erfolgreich angemeldet",
      },
      verifiedSwitchTab: {
        subtitle: "Kehre zum neu geöffneten Tab zurück, um fortzufahren",
        subtitleNewTab: "Kehre zum vorherigen Tab zurück, um fortzufahren",
        title: "E-Mail erfolgreich verifiziert",
      },
    },
    legalConsent: {
      checkbox: {
        label__onlyPrivacyPolicy:
          'Ich stimme der {{ privacyPolicyLink || link("Datenschutzerklärung") }} zu',
        label__onlyTermsOfService:
          'Ich stimme den {{ termsOfServiceLink || link("Nutzungsbedingungen") }} zu',
        label__termsOfServiceAndPrivacyPolicy:
          'Ich stimme den {{ termsOfServiceLink || link("Nutzungsbedingungen") }} und der {{ privacyPolicyLink || link("Datenschutzerklärung") }} zu',
      },
      continue: {
        subtitle: "Bitte lies und akzeptiere die Bedingungen, um fortzufahren",
        title: "Rechtliche Einwilligung",
      },
    },
    phoneCode: {
      formSubtitle:
        "Gib den Bestätigungscode ein, der an deine Telefonnummer gesendet wurde",
      formTitle: "Bestätigungscode",
      resendButton: "Code erneut senden",
      subtitle: "weiter zu {{applicationName}}",
      title: "Verifiziere deine Telefonnummer",
    },
    restrictedAccess: {
      actionLink: "Mehr erfahren",
      actionText: "Zugang verweigert?",
      blockButton__emailSupport: "E-Mail-Support kontaktieren",
      blockButton__joinWaitlist: "Warteliste beitreten",
      subtitle: "Dein Zugang ist momentan eingeschränkt.",
      subtitleWaitlist:
        "Tritt der Warteliste bei, um Benachrichtigungen zu erhalten.",
      title: "Zugang verweigert",
    },
    start: {
      actionLink: "Einloggen",
      actionLink__use_email: "Mit E-Mail einloggen",
      actionLink__use_phone: "Mit Telefonnummer einloggen",
      actionText: "Hast du ein Konto?",
      subtitle: "weiter zu {{applicationName}}",
      title: "Erstelle deinen Account",
    },
  },
  socialButtonsBlockButton: "Weiter mit {{provider|titleize}}",
  socialButtonsBlockButtonManyInView: "{{provider|titleize}}",
  unstable__errors: {
    already_a_member_in_organization:
      "Du bist bereits Mitglied in dieser Organisation.",
    captcha_invalid:
      "Anmeldung aufgrund fehlgeschlagener Sicherheitsüberprüfung nicht erfolgreich. Bitte versuche es erneut oder kontaktiere uns für weitere Unterstützung.",
    captcha_unavailable:
      "Die Anmeldung ist aufgrund einer fehlgeschlagenen Bot-Validierung fehlgeschlagen. Bitte aktualisiere die Seite, um es erneut zu versuchen, oder wende dich an den Support, um weitere Unterstützung zu erhalten.",
    form_code_incorrect:
      "Der eingegebene Code ist falsch. Bitte überprüfe ihn und versuche es erneut.",
    form_identifier_exists:
      "Diese E-Mail-Adresse ist bereits vergeben. Bitte wähle eine andere.",
    form_identifier_exists__email_address:
      "Diese E-Mail-Adresse ist bereits vergeben. Bitte wähle eine andere.",
    form_identifier_exists__phone_number:
      "Diese Telefonnummer ist bereits vergeben. Bitte wähle eine andere.",
    form_identifier_exists__username:
      "Dieser Benutzername ist bereits vergeben. Bitte wähle einen anderen.",
    form_identifier_not_found:
      "Wir konnten kein Konto mit diesen Details finden.",
    form_param_format_invalid:
      "Das Format des eingegebenen Parameters ist ungültig.",
    form_param_format_invalid__email_address:
      "Bitte gib eine gültige E-Mail-Adresse ein.",
    form_param_format_invalid__phone_number:
      "Die Telefonnummer muss ein gültiges internationales Format haben",
    form_param_max_length_exceeded__first_name:
      "Der Vorname sollte nicht mehr als 256 Zeichen umfassen.",
    form_param_max_length_exceeded__last_name:
      "Der Nachname sollte nicht mehr als 256 Zeichen umfassen.",
    form_param_max_length_exceeded__name:
      "Der Name sollte nicht länger als 256 Zeichen sein.",
    form_param_nil:
      "Ein erforderliches Feld wurde nicht ausgefüllt. Bitte überprüfe deine Eingaben.",
    form_param_value_invalid:
      "Der eingegebene Wert ist ungültig oder enthält ungültige Zeichen. Bitte versuche einen anderen.",
    form_password_incorrect: "Das eingegebene Passwort ist falsch.",
    form_password_length_too_short:
      "Das Passwort ist zu kurz. Es muss mindestens 8 Zeichen lang sein.",
    form_password_not_strong_enough: "Passwort nicht stark genug",
    form_password_pwned:
      "Das gewählte Passwort wurde bei einem Datenleck im Internet gefunden. Wähle aus Sicherheitsgründen bitte ein anderes Passwort",
    form_password_pwned__sign_in:
      "Dieses Passwort wurde in einem Datenleck gefunden und kann nicht verwendet werden. Bitte setze dein Passwort zurück.",
    form_password_size_in_bytes_exceeded:
      "Das Passwort hat die maximale Anzahl an Bytes überschritten. Bitte kürze oder Sonderzeichen entfernen.",
    form_password_validation_failed: "Falsches Passwort",
    form_username_invalid_character:
      "Der Benutzername enthält ungültige Zeichen. Bitte verwende nur alphanumerische Zeichen und Unterstriche.",
    form_username_invalid_length:
      "Der Benutzername muss zwischen 3 und 30 Zeichen lang sein.",
    identification_deletion_failed:
      "Du kannst deine letzte Kennung nicht löschen.",
    not_allowed_access:
      "Deine E-Mail-Adresse oder Telefonnummer ist für die Anmeldung nicht zulässig. Dies kann daran liegen, dass deine E-Mail-Adresse die Zeichen '+', '=', '#' oder '.' enthält, du eine Domain verwendest, die mit einem temporären E-Mail-Dienst verknüpft ist, oder dass du explizit gesperrt bist. Wenn du glaubst, dass dies ein Fehler ist, wende dich bitte an den Support.",
    organization_domain_blocked:
      "Diese E-Mail-Provider-Domain ist gesperrt. Bitte verwende eine andere.",
    organization_domain_common:
      "Dies ist eine gängige E-Mail-Provider-Domain. Bitte verwende eine andere.",
    organization_membership_quota_exceeded:
      "Du hast dein Limit an Organisationsmitgliedschaften einschließlich ausstehender Einladungen erreicht.",
    organization_minimum_permissions_needed:
      "Es muss mindestens ein Organisationsmitglied mit den erforderlichen Mindestberechtigungen geben.",
    passkey_already_exists:
      "Auf diesem Gerät ist bereits ein Passkey registriert.",
    passkey_not_supported:
      "Passkeys werden auf diesem Gerät nicht unterstützt.",
    passkey_pa_not_supported:
      "Die Registrierung erfordert einen Plattformauthentifikator, der vom Gerät nicht unterstützt wird.",
    passkey_registration_cancelled:
      "Die Passkey-Registrierung wurde abgebrochen oder das Zeitlimit wurde überschritten.",
    passkey_retrieval_cancelled:
      "Die Passkey-Registrierung wurde abgebrochen oder das Zeitlimit wurde überschritten.",
    passwordComplexity: {
      maximumLength: "weniger als {{length}} Zeichen lang sein",
      minimumLength: "mindestens {{length}} Zeichen lang sein",
      requireLowercase: "einen Kleinbuchstaben enthalten",
      requireNumbers: "eine Zahl enthalten",
      requireSpecialCharacter: "ein Sonderzeichen enthalten",
      requireUppercase: "einen Großbuchstaben enthalten",
      sentencePrefix: "Das Passwort muss",
    },
    phone_number_exists:
      "Diese Telefonnummer ist bereits vergeben. Bitte wähle eine andere.",
    zxcvbn: {
      couldBeStronger:
        "Dein Passwort funktioniert, könnte aber besser sein. Versuche, mehr Zeichen hinzuzufügen.",
      goodPassword: "Dein Passwort erfüllt alle notwendigen Anforderungen.",
      notEnough: "Dein Passwort ist nicht stark genug.",
      suggestions: {
        allUppercase: "Einige, aber nicht alle Buchstaben groß schreiben.",
        anotherWord:
          "Weitere Wörter, die weniger häufig vorkommen, hinzufügen.",
        associatedYears:
          "Jahre, die mit persönlichen Daten in Verbindung gebracht werden können, vermeiden.",
        capitalization: "Nicht nur den ersten Buchstaben groß schreiben.",
        dates:
          "Daten, die mit persönlichen Daten in Verbindung gebracht werden können, vermeiden.",
        l33t: "Vorhersehbare Buchstabenersetzungen wie '@' für 'a' vermeiden.",
        longerKeyboardPattern:
          "Längere Tastaturmuster in unterschiedlicher Tipprichtung verwenden.",
        noNeed:
          "Es ist möglich, starke Passwörter zu erstellen, ohne Symbole, Zahlen oder Großbuchstaben zu verwenden.",
        pwned:
          "Wenn du dieses Passwort an anderer Stelle verwendest, solltest du es ändern.",
        recentYears: "Die jüngsten Jahreszahlen vermeiden.",
        repeated: "Wort- und Zeichenwiederholungen vermeiden.",
        reverseWords:
          "Umgekehrte Schreibweise von gebräuchlichen Wörtern vermeiden.",
        sequences: "Häufige Zeichenfolgen vermeiden.",
        useWords:
          "Mehrere Wörter verwenden, aber allgemeine Phrasen vermeiden.",
      },
      warnings: {
        common: "Dies ist ein oft verwendetes Passwort.",
        commonNames: "Vornamen und Nachnamen sind leicht zu erraten.",
        dates: "Ein Datum ist leicht zu erraten.",
        extendedRepeat:
          'Sich wiederholende Zeichenmuster wie "abcabcabc" sind leicht zu erraten.',
        keyPattern: "Kurze Tastaturmuster sind leicht zu erraten.",
        namesByThemselves:
          "Einzelne Namen oder Nachnamen sind leicht zu erraten.",
        pwned:
          "Dein Passwort wurde durch eine Datenpanne im Internet offengelegt.",
        recentYears: "Die jüngsten Jahreszahlen sind leicht zu erraten.",
        sequences: 'Häufige Zeichenfolgen wie "abc" sind leicht zu erraten.',
        similarToCommon:
          "Dies weist Ähnlichkeit zu anderen oft verwendeten Passwörtern auf.",
        simpleRepeat:
          'Sich wiederholende Zeichen wie "aaa" sind leicht zu erraten.',
        straightRow:
          "Gerade Linien von Tasten auf der Tastatur sind leicht zu erraten.",
        topHundred: "Dies ist ein häufig verwendetes Passwort.",
        topTen: "Dies ist ein sehr häufig verwendetes Passwort.",
        userInputs:
          "Es sollten keine persönlichen oder seitenrelevanten Daten vorkommen.",
        wordByItself: "Einzelne Wörter sind leicht zu erraten.",
      },
    },
  },
  userButton: {
    action__addAccount: "Konto hinzufügen",
    action__manageAccount: "Konto verwalten",
    action__signOut: "Ausloggen",
    action__signOutAll: "Melde dich von allen Konten ab",
  },
  userProfile: {
    backupCodePage: {
      actionLabel__copied: "Kopiert!",
      actionLabel__copy: "Kopiere alle",
      actionLabel__download: "Lade .txt herunter",
      actionLabel__print: "Drucken",
      infoText1: "Backup-Codes werden für dieses Konto aktiviert.",
      infoText2:
        "Halte die Backup-Codes geheim und bewahre sie sicher auf. Du kannst Sicherungscodes neu generieren, wenn du vermutest, dass sie kompromittiert wurden.",
      subtitle__codelist: "Bewahre die Codes sicher auf und halte sie geheim.",
      successMessage:
        "Sicherungscodes sind jetzt aktiviert. Du kannst eines davon verwenden, um dich bei deinem Konto anzumelden, wenn du den Zugriff auf dein Authentifizierungsgerät verlierst. Jeder Code kann nur einmal verwendet werden.",
      successSubtitle:
        "Du kannst diese Codes verwenden, um dich bei deinem Konto anzumelden, wenn du den Zugriff auf dein Authentifizierungsgerät verlierst.",
      title: "Backup-Code-Verifizierung hinzufügen",
      title__codelist: "Sicherungscodes",
    },
    billingPage: {
      paymentSourcesSection: {
        actionLabel__default: "Als Standard festlegen",
        actionLabel__remove: "Entfernen",
        add: "Neue Zahlungsmethode hinzufügen",
        addSubtitle: "Füge eine neue Zahlungsmethode hinzu.",
        cancelButton: "Abbrechen",
        formButtonPrimary__add: "Zahlungsmethode hinzufügen",
        formButtonPrimary__pay: "{{amount}} bezahlen",
        payWithTestCardButton: "Mit Test-Kreditkarte bezahlen",
        removeResource: {
          messageLine1: "{{identifier}} wird von diesem Konto entfernt.",
          messageLine2:
            "In Zukunft kannst du diese Zahlungsmethode nicht mehr verwenden. Alle laufenden Abonnements, die diese Zahlungsmethode verwenden, werden aufhören zu funktionieren.",
          successMessage: "{{paymentSource}} wurde von diesem Konto entfernt.",
          title: "Zahlungsmethode entfernen",
        },
        title: "Zahlungsmethoden",
      },
      start: {
        headerTitle__plans: "Pläne",
        headerTitle__statements: "Abrechnungen",
        headerTitle__subscriptions: "Abonnements",
      },
      subscriptionsListSection: {
        actionLabel__newSubscription: "Plan abonnieren",
        actionLabel__switchPlan: "Plan wechseln",
        title: "Abonnement",
      },
      subscriptionsSection: {
        actionLabel__default: "Verwalten",
      },
      switchPlansSection: {
        title: "Plan wechseln",
      },
      title: "Abrechnung",
    },
    connectedAccountPage: {
      formHint: "Wähle einen Anbieter aus, um dein Konto zu verbinden.",
      formHint__noAccounts: "Es sind keine externen Kontoanbieter verfügbar.",
      removeResource: {
        messageLine1: "{{identifier}} wird aus diesem Konto entfernt.",
        messageLine2:
          "Du kannst dieses verbundene Konto nicht mehr verwenden und alle abhängigen Funktionen funktionieren nicht mehr.",
        successMessage: "{{connectedAccount}} wurde aus deinem Konto entfernt.",
        title: "Verbundenes Konto entfernen",
      },
      socialButtonsBlockButton: "{{provider|titleize}}-Konto verbinden",
      successMessage: "Der Anbieter wurde deinem Konto hinzugefügt",
      title: "Verbundenes Konto hinzufügen",
    },
    deletePage: {
      actionDescription: 'Gib "Konto löschen" ein, um fortzufahren.',
      confirm: "Konto löschen",
      messageLine1: "Bist du sicher, dass du dein Konto löschen möchtest?",
      messageLine2:
        "Diese Aktion ist endgültig und kann nicht rückgängig gemacht werden.",
      title: "Konto löschen",
    },
    emailAddressPage: {
      emailCode: {
        formHint:
          "An diese E-Mail-Adresse wird eine E-Mail mit einem Bestätigungscode gesendet.",
        formSubtitle:
          "Gib den Bestätigungscode ein, der an {{identifier}} gesendet wird",
        formTitle: "Verifizierungs-Schlüssel",
        resendButton: "Code erneut senden",
        successMessage:
          "Die E-Mail-Adresse {{identifier}} wurde deinem Konto hinzugefügt.",
      },
      emailLink: {
        formHint:
          "An diese E-Mail-Adresse wird eine E-Mail mit einem Bestätigungslink gesendet.",
        formSubtitle:
          "Klicke auf den Bestätigungslink in der an {{identifier}} gesendeten E-Mail",
        formTitle: "Bestätigungslink",
        resendButton: "Link erneut senden",
        successMessage:
          "Die E-Mail-Adresse {{identifier}} wurde deinem Konto hinzugefügt.",
      },
      removeResource: {
        messageLine1: "{{identifier}} wird aus diesem Konto entfernt.",
        messageLine2:
          "Du kannst dich nicht mehr mit dieser E-Mail-Adresse anmelden.",
        successMessage: "{{emailAddress}} wurde aus deinem Konto entfernt.",
        title: "E-Mail-Adresse entfernen",
      },
      title: "E-Mail-Adresse hinzufügen",
      verifyTitle: "E-Mail Adresse verifizieren",
    },
    formButtonPrimary__add: "Hinzufügen",
    formButtonPrimary__continue: "Fortsetzen",
    formButtonPrimary__finish: "Fertig",
    formButtonPrimary__remove: "Entfernen",
    formButtonPrimary__save: "Speichern",
    formButtonReset: "Abbrechen",
    mfaPage: {
      formHint: "Wähle eine Methode aus.",
      title: "Aktiviere die Zweifaktor-Authentifizierung",
    },
    mfaPhoneCodePage: {
      backButton: "Vorhandene Nummer verwenden",
      primaryButton__addPhoneNumber: "Füge eine Telefonnummer hinzu",
      removeResource: {
        messageLine1:
          "{{identifier}} erhält bei der Anmeldung keine Bestätigungscodes mehr.",
        messageLine2:
          "Dein Konto ist möglicherweise nicht so sicher. Bist du dir sicher, dass du weitermachen willst?",
        successMessage:
          "SMS-Code-Bestätigung in zwei Schritten wurde für {{mfaPhoneCode}} entfernt",
        title: "Entferne die Bestätigung in zwei Schritten",
      },
      subtitle__availablePhoneNumbers:
        "Wähle eine Telefonnummer aus, um dich für die Bestätigung in zwei Schritten per SMS-Code zu registrieren.",
      subtitle__unavailablePhoneNumbers:
        "Es sind keine Telefonnummern verfügbar, um sich für die SMS-Code-Bestätigung in zwei Schritten zu registrieren.",
      successMessage1:
        "Bei der Anmeldung musst du einen Bestätigungscode eingeben, der an diese Telefonnummer gesendet wird, als zusätzlichen Schritt.",
      successMessage2:
        "Bewahre diese Sicherungscodes auf und speichere sie an einem sicheren Ort. Wenn du den Zugriff auf dein Authentifizierungsgerät verlierst, kannst du Sicherungscodes verwenden, um dich anzumelden.",
      successTitle: "SMS-Code-Bestätigung aktiviert",
      title: "SMS-Code-Bestätigung hinzufügen",
    },
    mfaTOTPPage: {
      authenticatorApp: {
        buttonAbleToScan__nonPrimary: "Scanne stattdessen den QR-Code",
        buttonUnableToScan__nonPrimary: "QR-Code kann nicht gescannt werden?",
        infoText__ableToScan:
          "Richte eine neue Anmeldemethode in deiner Authentifizierungs-App ein und scanne den folgenden QR-Code, um ihn mit deinem Konto zu verknüpfen.",
        infoText__unableToScan:
          "Richte eine neue Anmeldemethode in deinem Authentifikator ein und gib den unten angegebenen Schlüssel ein.",
        inputLabel__unableToScan1:
          "Stelle sicher, dass zeitbasierte oder einmalige Passwörter aktiviert sind, und schließe dann die Verknüpfung deines Kontos ab.",
        inputLabel__unableToScan2:
          "Wenn dein Authentifikator TOTP-URIs unterstützt, kannst du alternativ auch die vollständige URI kopieren.",
      },
      removeResource: {
        messageLine1:
          "Bei der Anmeldung sind keine Bestätigungscodes von diesem Authentifikator mehr erforderlich.",
        messageLine2:
          "Dein Konto ist möglicherweise nicht mehr so sicher. Bist du dir sicher, dass du fortfahren willst?",
        successMessage:
          "Die zweistufige Verifizierung über die Authentifizierungs-App wurde entfernt.",
        title: "Entferne die Bestätigung in zwei Schritten",
      },
      successMessage:
        "Die Bestätigung in zwei Schritten ist jetzt aktiviert. Bei der Anmeldung musst du als zusätzlichen Schritt einen Bestätigungscode von diesem Authentifikator eingeben.",
      title: "Authentifizierungs-App hinzufügen",
      verifySubtitle:
        "Gib den von deinem Authentifikator generierten Bestätigungscode ein",
      verifyTitle: "Verifizierungs-Schlüssel",
    },
    mobileButton__menu: "Menü",
    navbar: {
      account: "Profil",
      billing: "Abrechnung",
      description: "Verwalte deine Kontoinformationen.",
      security: "Sicherheit",
      title: "Benutzerkonto",
    },
    passkeyScreen: {
      removeResource: {
        messageLine1: "{{name}} wird von diesem Konto entfernt.",
        title: "Passkey entfernen",
      },
      subtitle__rename:
        "Du kannst den Namen des Passkeys ändern, um ihn leichter zu finden.",
      title__rename: "Passkey umbenennen",
    },
    passwordPage: {
      checkboxInfoText__signOutOfOtherSessions:
        "Es wird empfohlen, sich von allen anderen Geräten abzumelden, die möglicherweise dein altes Passwort verwendet haben.",
      readonly:
        "Dein Passwort kann derzeit nicht geändert werden, da du dich nur über die Enterprise-Verbindung anmelden kannst.",
      successMessage__set: "Dein Passwort wurde festgelegt.",
      successMessage__signOutOfOtherSessions:
        "Alle anderen Geräte wurden abgemeldet.",
      successMessage__update: "Dein Passwort wurde aktualisiert.",
      title__set: "Passwort festlegen",
      title__update: "Passwort ändern",
    },
    phoneNumberPage: {
      infoText:
        "An diese Telefonnummer wird eine SMS mit einem Bestätigungslink gesendet.",
      removeResource: {
        messageLine1: "{{identifier}} wird aus diesem Konto entfernt.",
        messageLine2:
          "Du kannst dich nicht mehr mit dieser Telefonnummer anmelden.",
        successMessage: "{{phoneNumber}} wurde aus deinem Konto entfernt.",
        title: "Telefonnummer entfernen",
      },
      successMessage: "{{identifier}} wurde deinem Konto hinzugefügt.",
      title: "Telefonnummer hinzufügen",
      verifySubtitle:
        "Gib den Bestätigungscode ein, der an {{identifier}} gesendet wurde",
      verifyTitle: "Telefonnummer verifizieren",
    },
    plansPage: {
      title: "Pläne",
    },
    profilePage: {
      fileDropAreaHint:
        "Lade ein JPG-, PNG-, GIF- oder WEBP-Bild hoch, welches kleiner als 10 MB ist",
      imageFormDestructiveActionSubtitle: "Bild entfernen",
      imageFormSubtitle: "Bild hochladen",
      imageFormTitle: "Profilbild",
      readonly:
        "Deine Profilinformationen wurden von der Enterprise-Verbindung bereitgestellt und können nicht bearbeitet werden.",
      successMessage: "Dein Profil wurde aktualisiert.",
      title: "Profil aktualisieren",
    },
    start: {
      activeDevicesSection: {
        destructiveAction: "Vom Gerät abmelden",
        title: "Aktive Geräte",
      },
      connectedAccountsSection: {
        actionLabel__connectionFailed: "Versuche es nochmal",
        actionLabel__reauthorize: "Jetzt autorisieren",
        destructiveActionTitle: "Entfernen",
        primaryButton: "Konto verbinden",
        subtitle__disconnected:
          "Dein Konto ist derzeit getrennt. Bitte verbinde es erneut.",
        subtitle__reauthorize:
          "Die erforderlichen Berechtigungen wurden aktualisiert, und du erlebst möglicherweise eingeschränkte Funktionalität. Bitte autorisiere diese Anwendung erneut, um Probleme zu vermeiden.",
        title: "Verbundene Konten",
      },
      dangerSection: {
        deleteAccountButton: "Konto löschen",
        title: "Achtung",
      },
      emailAddressesSection: {
        destructiveAction: "E-Mail-Adresse entfernen",
        detailsAction__nonPrimary: "Als primär festlegen",
        detailsAction__primary: "Verifizierung abschließen",
        detailsAction__unverified: "Verifizierung abschließen",
        primaryButton: "Füge eine E-Mail-Adresse hinzu",
        title: "E-Mail-Adressen",
      },
      enterpriseAccountsSection: {
        title: "Unternehmens-Konten",
      },
      headerTitle__account: "Konto",
      headerTitle__security: "Sicherheit",
      mfaSection: {
        backupCodes: {
          actionLabel__regenerate: "Codes neu generieren",
          headerTitle: "Backup-Codes",
          subtitle__regenerate:
            "Generiere einen neuen Satz sicherer Backup-Codes. Alte Backup-Codes werden gelöscht und können nicht mehr verwendet werden.",
          title__regenerate: "Backup-Codes neu generieren",
        },
        phoneCode: {
          actionLabel__setDefault: "Als Standard einstellen",
          destructiveActionLabel: "Telefonnummer entfernen",
        },
        primaryButton: "Aktiviere die Zweifaktor-Authentifizierung",
        title: "Zweifaktor-Authentifizierung",
        totp: {
          destructiveActionTitle: "Entfernen",
          headerTitle: "Authentifizierungs-App",
        },
      },
      passkeysSection: {
        menuAction__destructive: "Entfernen",
        menuAction__rename: "Umbenennen",
        primaryButton: "Passkey hinzufügen",
        title: "Passkeys",
      },
      passwordSection: {
        primaryButton__setPassword: "Passwort festlegen",
        primaryButton__updatePassword: "Passwort ändern",
        title: "Passwort",
      },
      phoneNumbersSection: {
        destructiveAction: "Telefonnummer entfernen",
        detailsAction__nonPrimary: "Als primär festlegen",
        detailsAction__primary: "Verifizierung abschließen",
        detailsAction__unverified: "Verifizierung abschließen",
        primaryButton: "Füge eine Telefonnummer hinzu",
        title: "Telefonnummern",
      },
      profileSection: {
        primaryButton: "Profil bearbeiten",
        title: "Profil",
      },
      usernameSection: {
        primaryButton__setUsername: "Benutzernamen festlegen",
        primaryButton__updateUsername: "Benutzernamen ändern",
        title: "Nutzername",
      },
      web3WalletsSection: {
        destructiveAction: "Wallet entfernen",
        detailsAction__nonPrimary: "Als primär festlegen",
        primaryButton: "Web3-Wallets",
        title: "Web3-Wallets",
      },
    },
    usernamePage: {
      successMessage: "Dein Benutzername wurde aktualisiert.",
      title__set: "Benutzernamen aktualisieren",
      title__update: "Benutzernamen aktualisieren",
    },
    web3WalletPage: {
      removeResource: {
        messageLine1: "{{identifier}} wird aus diesem Konto entfernt.",
        messageLine2:
          "Du kannst dich nicht mehr mit diesem Web3-Wallet anmelden.",
        successMessage: "{{web3Wallet}} wurde aus deinem Konto entfernt.",
        title: "Entferne das Web3-Wallet",
      },
      subtitle__availableWallets:
        "Wähle ein Web3-Wallet aus, um dich mit deinem Konto zu verbinden.",
      subtitle__unavailableWallets: "Es sind keine Web3-Wallets verfügbar.",
      successMessage: "Die Brieftasche wurde deinem Konto hinzugefügt.",
      title: "Web3-Wallet hinzufügen",
      web3WalletButtonsBlockButton: "{{provider|titleize}}",
    },
  },
  waitlist: {
    start: {
      actionLink: "Jetzt anmelden",
      actionText: "Kein Zugang? Auf die Warteliste setzen!",
      formButton: "Zur Warteliste hinzufügen",
      subtitle: "Es tut uns leid, aber derzeit sind keine Plätze verfügbar.",
      title: "Warteliste beitreten",
    },
    success: {
      message:
        "Du wurdest erfolgreich auf die Warteliste gesetzt. Wir benachrichtigen dich, sobald Plätze verfügbar sind.",
      subtitle:
        "Vielen Dank für deine Geduld. Du erhältst eine Benachrichtigung, sobald der Zugang freigegeben wird.",
      title: "Erfolgreich auf die Warteliste gesetzt",
    },
  },
};
